// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"225":"2f045543","354":"30d07ebe","418":"0f63ae9c","594":"5a11101f"}[chunkId] + ".js";
};